/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverForecastFormRemoveTank: "receiver-forecast-form-remove-tank",
  receiverForecastFormAddTank: "receiver-forecast-form-add-tank",
  receiverForecastFormPrevious: "receiver-forecast-form-previous",
  receiverForecastFormNextOrSubmit: "receiver-forecast-form-next-or-submit",
  receiverForecastFormThresholdSelector: "receiver-forecast-form-threshold-selector",
  receiverForecastFormThresholdOption: "receiver-forecast-form-threshold-option",
} as const;
